import CloseIcon from "@mui/icons-material/Close";
import { Box, Card, CardActions, CardContent, Checkbox, FormControlLabel, IconButton, styled } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { styled as styled2 } from "@mui/system";
import MDBox from "components/MDBox";
import MDAlert from "components/MDAlert";
import { AuthContext } from "context";
import { createMRTColumnHelper } from "material-react-table";
import { useContext, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useNavigate, useParams } from "react-router-dom";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import showToast from "../../utils/toast";

const DraggableBox = styled2(Card)(({ theme }) => ({
	minHeight: "200px",
	padding: theme.spacing(2),
	marginTop: theme.spacing(2),
	backgroundColor: theme.palette.background.paper,
}));

const ScrollableBox = styled(Box)(({ theme }) => ({
	display: "flex",
	overflowX: "auto",
	padding: theme.spacing(2),
	"&::-webkit-scrollbar": {
		height: "6px",
	},
	"&::-webkit-scrollbar-thumb": {
		backgroundColor: theme.palette.grey[300],
		borderRadius: "3px",
	},
}));

const DocumentCard = styled(Card)(({ theme }) => ({
	width: "250px",
	minWidth: "250px",
	marginRight: theme.spacing(2),
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-between",
}));

function SecurityDocumentManagment() {
	const { id, areaName } = useParams();
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const [data, setData] = useState([]);
	const [generalDocuments, setGeneralDocuments] = useState([]);
	const [selectedDocuments, setSelectedDocuments] = useState([]);
	const [selectedDocumentsOriginals, setSelectedDocumentsOriginals] = useState([]);
	const [loading, setLoading] = useState(false);

	const handleSetNotification = (msg, severityType) => {
		showToast(msg, severityType);
	};

	function fetchData() {
		apiService
			.get("/document-security-management/", { id_area: id }, {})
			.then((data) => {
				setData(data);
			})
			.catch((error) => handleSetNotification("Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #0846183649930", "error"));
	}

	function fetchGeneralDocuments() {
		setLoading(true);
		apiService
			.get("/general-security-area/", { id_area: id }, {})
			.then((generealDocumetsExists) => {
				setSelectedDocuments(generealDocumetsExists);
				setSelectedDocumentsOriginals(JSON.parse(JSON.stringify(generealDocumetsExists)));
				apiService
					.get("/general-security-management/", {}, {})
					.then((data) => {
						const generalDocumentsFiltred = data.filter((document) => !generealDocumetsExists.some((existingDocument) => existingDocument.id === document.id));
						setGeneralDocuments(generalDocumentsFiltred);
						setLoading(false);
					})
					.catch((error) => {
						handleSetNotification("Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #0990959027430", "error");
						setLoading(false);
					});
			})
			.catch((error) => {
				handleSetNotification("Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #053715239930", "error");
				setLoading(false);
			});
	}

	useEffect(() => {}, []);

	useEffect(() => {
		if (id) {
			fetchData();
			fetchGeneralDocuments();
		}
		// Fetch general documents (this is a mock, replace with actual API call)
		/*setGeneralDocuments([
      {
        id: 1,
        name: "Documento 1",
        has_expiration: true,
        additional_fields: [
          { name: "Campo 1", required: true },
          { name: "Campo 2", required: false },
        ],
      },
      { id: 2, name: "Documento 2", has_expiration: false, additional_fields: [{ name: "Campo 3", required: true }] },
      { id: 3, name: "Documento 3", has_expiration: true, additional_fields: [] },
    ])*/
	}, [id]);

	const columnHelper = createMRTColumnHelper();

	async function deleteResource(id) {
		try {
			const endpoint = `/document-security-management/`;
			const params = { id: id };
			const headers = {};
			const response = await apiService.delete(endpoint, params, headers);
			console.log(`Risorsa con id ${id} eliminata con successo:`, response);
			return response;
		} catch (error) {
			console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);
			throw error;
		}
	}

	function handleDelete(id) {
		if (window.confirm("Sei sicuro di voler eliminare questo documento?\n Attenzione questa operazione è irreversibile.")) {
			deleteResource(id)
				.then((result) => {
					handleSetNotification("Utente eliminato con successo", "success");
					fetchData();
				})
				.catch((error) => {
					handleSetNotification("Si è verificato un errore durante l'eliminazione del utente. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #00032", "error");
				});
		}
	}

	const columns = [
		columnHelper.accessor("name", {
			header: "Nome documento",
			size: 120,
		}),
		columnHelper.accessor("address", {
			header: "Documenti",
			size: 120,
			Cell: ({ row }) =>
				authContext?.hasAuth("UPSERT_DOCUMENTS_AREA") && (
					<MDButton onClick={() => navigate("/security-document-area-add/" + id + "/" + areaName + "/" + row.original.id)} size="small">
						{" "}
						MODIFICA{" "}
					</MDButton>
				),
		}),
	];

	const handleDocumentSelect = (document) => {
		setSelectedDocuments((prev) => [...prev, { ...document, required: false }]);
		setGeneralDocuments((prev) => prev.filter((doc) => doc.id !== document.id));
	};

	const handleRequiredChange = (index) => {
		setSelectedDocuments((prev) => {
			const newDocs = [...prev];
			newDocs[index].required = !newDocs[index].required;
			return newDocs;
		});
	};

	const handleRemoveDocument = (document) => {
		if (!selectedDocumentsOriginals.some((existingDocument) => existingDocument.id === document.id)) {
			setSelectedDocuments((prev) => prev.filter((doc) => doc.id !== document.id));
			setGeneralDocuments((prev) => [...prev, document]);
		} else {
			if (window.confirm("Sei sicuro di voler rimuovere questo documento? Dopo che avrai salvato l'operazione sarà irreversibile.")) {
				setSelectedDocuments((prev) => prev.filter((doc) => doc.id !== document.id));
				setGeneralDocuments((prev) => [...prev, document]);
			}
		}
	};

	const handleDragEnd = (result) => {
		if (!result.destination) return;
		const items = Array.from(selectedDocuments);
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);
		setSelectedDocuments(items);
	};

	const handleSave = () => {
		// Implement save logic here
		//console.log("Saving selected documents:", selectedDocuments)
		setLoading(true);
		apiService
			.post("/general-security-area/", {}, { area_id: id, documents: selectedDocuments })
			.then(() => {
				handleSetNotification("Documenti salvati con successo", "success");
				fetchGeneralDocuments();
			})
			.catch((error) => {
				setLoading(false);
				handleSetNotification("Si sono verificati degli errori durante il salvataggio dei documenti. Riprova più tardi se l'errore persiste contatti il supporto tecnico indicato l'errore #0261534590940032", "error");
			});
	};

	return (
		<DashboardLayout>
			{authContext?.hasAuth("VIEW_DOCUMENTS_AREA") ? (
				<>
					<DashboardNavbar />
					<MDBox pt={6} pb={3}>
						<MDTypography sx={{ textTransform: "uppercase" }} variant="h6" color="black">
							SICUREZZA CANTIERE {areaName}
						</MDTypography>
						{/* authContext?.hasAuth("UPSERT_DOCUMENTS_AREA") && <MDButton color={"dark"} onClick={() => navigate("/security-document-area-add/" + id + "/" + areaName)}>
            Aggiungi documento
          </MDButton>
          // Rimettere qua la chiusura del MDBox
        <GenericTable authModelName="DOCUMENTS_AREA" data={data} columns={columns} onDelete={handleDelete} disableButton={true} /> */}
					</MDBox>

					{!loading ? (
						<>
							<MDBox mt={4}>
								<MDTypography variant="h6" color="black" mb={2}>
									Documenti Generali
								</MDTypography>
								{authContext?.hasAuth("UPSERT_DOCUMENTS_AREA") && (
									<ScrollableBox>
										{generalDocuments.map((doc) => (
											<DocumentCard key={doc.id}>
												<CardContent>
													<MDTypography variant="h6">{doc.name}</MDTypography>
													<MDTypography variant="body2">Scadenza: {doc.has_expiration ? "Sì" : "No"}</MDTypography>
													{doc.additional_fields.map((field, index) => (
														<MDTypography key={index} variant="body2">
															{field.name}: {field.required ? "Obbligatorio" : "Opzionale"}
														</MDTypography>
													))}
												</CardContent>
												<CardActions>
													<MDButton size="small" color="secondary" onClick={() => handleDocumentSelect(doc)}>
														Aggiungi
													</MDButton>
												</CardActions>
											</DocumentCard>
										))}
									</ScrollableBox>
								)}
							</MDBox>

							<DragDropContext onDragEnd={handleDragEnd}>
								<Droppable droppableId="documents">
									{(provided) => (
										<DraggableBox ref={provided.innerRef} {...provided.droppableProps}>
											<MDTypography variant="h6" color="black" mb={2}>
												Documenti Selezionati
											</MDTypography>
											{selectedDocuments.map((doc, index) => (
												<Draggable key={doc.id} draggableId={doc.id.toString()} index={index}>
													{(provided) => (
														<Card ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} sx={{ mb: 2, p: 2, position: "relative" }}>
															<MDTypography variant="body1">{doc.name}</MDTypography>
															{authContext?.hasAuth("UPSERT_DOCUMENTS_AREA") ? (
																<FormControlLabel control={<Checkbox checked={doc.required} onChange={() => handleRequiredChange(index)} />} label="Obbligatorio" />
															) : (
																<MDTypography variant="body2">Obbligatorio: {doc.required ? "Obbligatorio" : "Facoltativo"}</MDTypography>
															)}
															{authContext?.hasAuth("UPSERT_DOCUMENTS_AREA") && (
																<IconButton size="small" onClick={() => handleRemoveDocument(doc)} sx={{ position: "absolute", top: 8, right: 8 }}>
																	<CloseIcon />
																</IconButton>
															)}
														</Card>
													)}
												</Draggable>
											))}
											{provided.placeholder}
										</DraggableBox>
									)}
								</Droppable>
							</DragDropContext>

							<center>
								{JSON.stringify(selectedDocuments) !== JSON.stringify(selectedDocumentsOriginals) && authContext?.hasAuth("UPSERT_DOCUMENTS_AREA") && (
									<MDButton sx={{ mt: 4 }} color="secondary" onClick={handleSave}>
										Salva Modifiche
									</MDButton>
								)}
							</center>
						</>
					) : (
						<center>
							<MDBox sx={{ mt: 8 }}>
								<CircularProgress size={120} sx={{ marginTop: "250px", color: "#2b84ea" }} />
							</MDBox>
						</center>
					)}
				</>
			) : (
				<MDBox sx={{ mt: 8 }}>
					<MDAlert color="error">Non hai i permessi per visualizzare questa pagina.</MDAlert>
				</MDBox>
			)}
		</DashboardLayout>
	);
}

export default SecurityDocumentManagment;
